import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40879fbc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sidebar-inner"
};
const _hoisted_2 = {
  class: "sidebar-top"
};
const _hoisted_3 = {
  class: "sidebar-title"
};
const _hoisted_4 = {
  class: "sidebar-buttons"
};
const _hoisted_5 = {
  class: "sidebar-button"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sidebar-line"
}, null, -1));
const _hoisted_7 = {
  class: "sidebar-type"
};
const _hoisted_8 = {
  class: "sidebar-type-box"
};
const _hoisted_9 = {
  class: "sidebar-type-number"
};
const _hoisted_10 = {
  class: "sidebar-type-name"
};
const _hoisted_11 = {
  class: "sidebar-content"
};
const _hoisted_12 = {
  class: "sidebar-content-inner"
};
const _hoisted_13 = {
  class: "sidebar-group-name"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "sidebar-item-date"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "sidebar-item-image"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src", "alt"];
const _hoisted_22 = {
  class: "sidebar-item-info"
};
const _hoisted_23 = {
  class: "sidebar-item-title"
};
const _hoisted_24 = {
  class: "sidebar-item-description"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_alerts_status = _resolveComponent("alerts-status");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['sidebar', {
      open: $props.modelValue
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass(['sidebar-title-circle', `${$options.title.toLowerCase()}-circle`])
  }, _toDisplayString($options.levelNumber), 3), _createTextVNode(" " + _toDisplayString($options.title), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_app_icon, {
    icon: "expand",
    onClick: $options.onExpand
  }, null, 8, ["onClick"])]), _hoisted_6, _createElementVNode("div", {
    class: "sidebar-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClose && $options.onClose(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    size: 24,
    color: "#757575"
  })])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($options.typeNumber), 1), _createElementVNode("div", _hoisted_10, _toDisplayString($options.name), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.contentItems, group => {
    return _openBlock(), _createElementBlock("div", {
      key: group.id,
      class: "sidebar-group"
    }, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_app_icon, {
      icon: "cart",
      size: 16,
      color: "#4D4D4D"
    }), _createTextVNode(" " + _toDisplayString(group.name), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item.id,
        class: _normalizeClass(['sidebar-item', {
          active: $props.selectedId == item.id
        }]),
        onClick: _withModifiers($event => $options.onToggleId(item.id), ["self"])
      }, [_createElementVNode("div", {
        class: "sidebar-item-top",
        onClick: _withModifiers($event => $options.onToggleId(item.id), ["self"])
      }, [_createVNode(_component_alerts_status, {
        modelValue: item.status,
        "onUpdate:modelValue": $event => item.status = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createElementVNode("div", {
        class: "sidebar-item-top-right",
        onClick: $event => $options.onToggleId(item.id)
      }, [_createElementVNode("div", _hoisted_17, _toDisplayString($options.createdAt(item.created_at)), 1), _createElementVNode("div", {
        class: "sidebar-item-avatar",
        style: _normalizeStyle($props.selectedId == item.id ? {
          color: item.assignee.color,
          backgroundColor: item.assignee.back,
          borderWidth: 0
        } : null)
      }, _toDisplayString(item.assignee.name[0]), 5)], 8, _hoisted_16)], 8, _hoisted_15), _createElementVNode("div", {
        class: "sidebar-item-bottom",
        onClick: $event => $options.onToggleId(item.id)
      }, [_createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
        src: item.main_image_link,
        alt: "",
        class: "sidebar-item-photo"
      }, null, 8, _hoisted_20), _createElementVNode("img", {
        src: _ctx.getCountryFlag(item.country_code),
        alt: item.country_code,
        class: "sidebar-item-flag"
      }, null, 8, _hoisted_21)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(item.product_title_amazon), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(item.alerting_message), 1)])], 8, _hoisted_18)], 10, _hoisted_14);
    }), 128))]);
  }), 128))])])])], 2);
}